/**
 * LandingPageLayout Component
 * Shared layout wrapper for landing pages
 */

import React from 'react';

import './landing-page-layout.scss';

export interface LandingPageLayoutProps {
    children: React.ReactNode;
    className?: string;
    wide?: boolean;
}

export const LandingPageLayout: React.FC<LandingPageLayoutProps> = ({ children, className = '', wide = false }) => {
    const classNames = ['landing-page', wide && 'landing-page--wide', className].filter(Boolean).join(' ');

    return (
        <div className={classNames}>
            <div className="landing-page__wrapper">{children}</div>
        </div>
    );
};

export default LandingPageLayout;
